document.addEventListener('DOMContentLoaded', function () {
  // Create global debugging functions immediately before initializing the bundle builder
  window.toggleBundleBuilderDebug = function() {
    if (window.bundleBuilder) {
      window.bundleBuilder.debugMode = !window.bundleBuilder.debugMode;
      if (window.bundleBuilder.debugOverlay) {
        window.bundleBuilder.debugOverlay.style.display = window.bundleBuilder.debugMode ? 'block' : 'none';
      }
      console.log(`Bundle Builder Debug Mode: ${window.bundleBuilder.debugMode ? 'ON' : 'OFF'}`);
      
      // Update the debug info if turning on
      if (window.bundleBuilder.debugMode && window.bundleBuilder.updateDebugOverlay) {
        window.bundleBuilder.updateDebugOverlay();
      }
      
      return `Debug mode is now ${window.bundleBuilder.debugMode ? 'ON' : 'OFF'}. Use toggleBundleBuilderDebug() to toggle.`;
    } else {
      console.warn('Bundle Builder not initialized yet or not found');
      return 'Bundle Builder not initialized yet or not found';
    }
  };
  
  window.bundleBuilderHelp = function() {
    console.log('Bundle Builder Debug Commands:');
    console.log('- toggleBundleBuilderDebug(): Toggle debug overlay');
    console.log('- bundleBuilder: Access the BundleBuilder instance (if available)');
    return 'See console for available commands';
  };

  class BundleBuilder {
    constructor() {
      this.selectedWatch = null;
      this.selectedStraps = [];
      this.maxStraps = 3;
      this.discountTiers = window.bundleBuilderSettings || { 1: 0.1, 2: 0.15, 3: 0.2 };
      this.viewMode = 'compatible';
      this.debugMode = false; // Debug mode off by default

      this.cacheDom();
      this.createDebugOverlay();
      this.bindEvents();
      this.updateSummary();
    }

    cacheDom() {
      this.watchItems = Array.from(document.querySelectorAll('#watchList .bundle-builder__product-item'));
      console.log('Watches found:', this.watchItems.length);
      
      // Try different selectors to find straps
      this.strapItems = Array.from(document.querySelectorAll('#strapList .bundle-builder__strap-item'));
      
      if (this.strapItems.length === 0) {
        // If no straps found with the .bundle-builder__strap-item class, try just using .bundle-builder__product-item inside #strapList
        this.strapItems = Array.from(document.querySelectorAll('#strapList .bundle-builder__product-item'));
        console.log('No straps found with .bundle-builder__strap-item class, trying .bundle-builder__product-item:', this.strapItems.length);
      }
      
      console.log('Straps found:', this.strapItems.length);
      
      // Log SKUs to verify data
      if (this.watchItems.length > 0) {
        console.log('Sample watch SKU:', this.watchItems[0].dataset.sku);
      }
      
      if (this.strapItems.length > 0) {
        console.log('Sample strap SKU:', this.strapItems[0].dataset.sku);
      } else {
        console.warn('No straps found! Checking DOM structure for #strapList:', document.getElementById('strapList'));
        
        // Further diagnostics
        const strapList = document.getElementById('strapList');
        if (strapList) {
          console.warn('Direct children of #strapList:', strapList.children.length);
          console.warn('All elements inside #strapList:', strapList.querySelectorAll('*').length);
          console.warn('First few HTML elements in #strapList:', strapList.innerHTML.substring(0, 200));
        }
      }
      
      this.summaryBar = document.getElementById('bundleSummary');
      this.selectedWrap = document.getElementById('selectedItems');
      this.totalEl = document.getElementById('bundleTotal');
      this.discountEl = document.getElementById('bundleDiscount');
      this.addBtn = document.getElementById('addBundleToCart');
      this.strapSearch = document.getElementById('strapSearch');
      this.viewToggleBtns = document.querySelectorAll('.bundle-builder__view-toggle button');
      this.tierIndicators = Array.from(document.querySelectorAll('.bundle-builder__tier-indicator'));
      this.strapListContainer = document.getElementById('strapList');
      this.noStrapsMsg = document.getElementById('noStraps');
    }

    createDebugOverlay() {
      this.debugOverlay = document.createElement('div');
      this.debugOverlay.style.position = 'fixed';
      this.debugOverlay.style.bottom = '5px';
      this.debugOverlay.style.left = '5px';
      this.debugOverlay.style.backgroundColor = 'blue';
      this.debugOverlay.style.color = 'white';
      this.debugOverlay.style.padding = '10px';
      this.debugOverlay.style.zIndex = '1000';
      this.debugOverlay.style.fontSize = '12px';
      this.debugOverlay.style.minWidth = '200px';
      this.debugOverlay.style.minHeight = '50px';
      this.debugOverlay.classList.add('bundle-builder__debug-overlay');
      
      // Hide debug overlay by default
      this.debugOverlay.style.display = 'none';
      
      document.body.appendChild(this.debugOverlay);
    }

    bindEvents() {
      this.watchItems.forEach(item => {
        item.addEventListener('click', () => this.selectWatch(item));
      });

      this.strapItems.forEach(item => {
        item.addEventListener('click', () => this.toggleStrap(item));
      });

      this.addBtn.addEventListener('click', () => this.addBundleToCart());

      this.strapSearch.addEventListener('input', () => this.handleStrapSearch());

      this.viewToggleBtns.forEach(btn => {
        btn.addEventListener('click', () => this.toggleView(btn.dataset.view));
      });

      // Bind model filter buttons
      const modelBtns = document.querySelectorAll('.bundle-builder__model-btn');
      modelBtns.forEach(btn => {
        btn.addEventListener('click', () => this.filterByModel(btn));
      });

      // Bind deselect buttons
      const deselectAllWatchesBtn = document.getElementById('deselectAllWatches');
      const deselectAllStrapsBtn = document.getElementById('deselectAllStraps');

      if (deselectAllWatchesBtn) {
        deselectAllWatchesBtn.addEventListener('click', () => this.deselectAllWatches());
      }

      if (deselectAllStrapsBtn) {
        deselectAllStrapsBtn.addEventListener('click', () => this.deselectAllStraps());
      }
    }

    selectWatch(item) {
      this.selectedWatch = {
        id: item.dataset.productId,
        variantId: item.dataset.variantId,
        price: parseInt(item.dataset.price, 10),
        title: item.querySelector('h3').textContent,
        image: item.dataset.image,
        sku: item.dataset.sku
      };

      this.watchItems.forEach(w => w.classList.toggle('selected', w === item));
      
      // Add watch-selected class to strap container for styling
      if (this.strapListContainer) {
        this.strapListContainer.classList.add('watch-selected');
      }
      
      this.filterStraps();
      this.updateSummary();
      this.updateDebugOverlay();
    }

    toggleStrap(item) {
      const data = {
        id: item.dataset.productId,
        variantId: item.dataset.variantId,
        price: parseInt(item.dataset.price, 10),
        title: item.querySelector('h3').textContent,
        image: item.dataset.image
      };

      if (item.classList.contains('selected')) {
        item.classList.remove('selected');
        this.selectedStraps = this.selectedStraps.filter(s => s.id !== data.id);
      } else {
        if (this.selectedStraps.length >= this.maxStraps) return;
        item.classList.add('selected');
        this.selectedStraps.push(data);
      }

      this.updateSummary();
      this.updateDebugOverlay();
    }

    updateSummary() {
      let total = this.selectedWatch ? this.selectedWatch.price : 0;
      this.selectedStraps.forEach(s => total += s.price);

      // Calculate discount based on total price
      const discountPercentage = this.discountTiers[this.selectedStraps.length] || 0;
      const discount = (total * discountPercentage) / 100;
      const final = total - discount;

      this.totalEl.textContent = this.formatMoney(final);
      this.discountEl.textContent = discount ? `Save ${this.formatMoney(discount)}` : '';
      this.addBtn.disabled = !(this.selectedWatch && this.selectedStraps.length);
      
      // Update summary bar visibility
      if (this.selectedWatch || this.selectedStraps.length) {
        this.summaryBar.classList.add('visible');
        this.summaryBar.classList.remove('hidden');
      } else {
        this.summaryBar.classList.remove('visible');
        this.summaryBar.classList.add('hidden');
      }
      
      // Update tier indicators
      if (this.tierIndicators) {
        this.tierIndicators.forEach(indicator => {
          const requiredStraps = parseInt(indicator.dataset.straps, 10);
          const discount = parseFloat(indicator.dataset.discount);
          const isActive = this.selectedStraps.length >= requiredStraps;
          indicator.classList.toggle('active', isActive);
          if (isActive) {
            const savings = (total * discount) / 100;
            this.discountEl.textContent = `Save ${this.formatMoney(savings)}`;
          }
        });
      }
    }

    addBundleToCart() {
      if (this.addBtn.disabled) return;

      const items = [
        { id: this.selectedWatch.variantId, quantity: 1 },
        ...this.selectedStraps.map(s => ({ id: s.variantId, quantity: 1 }))
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }).then(res => {
        if (!res.ok) throw new Error('Cart error');
        location.href = '/cart';
      }).catch(err => {
        console.error(err);
        this.addBtn.textContent = 'Error – try again';
      }).finally(() => {
        this.addBtn.disabled = false;
      });
    }

    handleStrapSearch() {
      const searchTerm = this.strapSearch.value.toLowerCase();
      this.filterStraps(searchTerm);
    }

    filterStraps(searchTerm = '') {
      if (!this.selectedWatch || !this.selectedWatch.sku) {
        // If no watch is selected, just apply search filter
        const straps = Array.from(this.strapItems);
        straps.forEach(strap => {
          const title = strap.dataset.title || '';
          const matchesSearch = !searchTerm || title.includes(searchTerm);
          strap.classList.toggle('hidden', !matchesSearch);
          
          // Reset compatibility classes
          strap.classList.remove('compatible', 'incompatible');
        });
        
        this.updateDebugOverlay();
        return;
      }

      const straps = Array.from(this.strapItems);
      let visibleCount = 0;
      
      straps.forEach(strap => {
        const title = strap.dataset.title || '';
        const strapSku = strap.dataset.sku;
        
        // Check compatibility
        let strapIsCompatible = false;
        try {
          if (strapSku) {
            strapIsCompatible = isCompatible(this.selectedWatch.sku, strapSku);
          }
        } catch (error) {
          console.error('Error in compatibility check:', error);
        }
        
        // Apply compatibility classes
        strap.classList.toggle('compatible', strapIsCompatible);
        strap.classList.toggle('incompatible', !strapIsCompatible);
        
        // Determine visibility based on search and view mode
        const matchesSearch = !searchTerm || title.includes(searchTerm);
        const matchesView = this.viewMode === 'all' || (this.viewMode === 'compatible' && strapIsCompatible);

        if (matchesSearch && matchesView) {
          strap.classList.remove('hidden');
          strap.style.order = strapIsCompatible ? '0' : '1'; // Compatible straps at the top
          visibleCount++;
        } else {
          strap.classList.add('hidden');
        }
      });

      // Show/hide no straps message
      const noStrapsMsg = document.getElementById('noStraps');
      if (noStrapsMsg) {
        noStrapsMsg.classList.toggle('hidden', visibleCount > 0);
      }

      this.updateDebugOverlay();
    }

    toggleView(view) {
      this.viewMode = view;
      this.viewToggleBtns.forEach(btn => btn.classList.toggle('active', btn.dataset.view === view));
      this.filterStraps(this.strapSearch.value.toLowerCase());
    }

    formatMoney(cents) {
      try {
        // Get currency from Shopify if available
        const shopCurrency = Shopify && Shopify.currency && Shopify.currency.active 
          ? Shopify.currency.active 
          : 'USD';
          
        // For Japanese Yen, don't divide by 100 and don't show decimal places
        if (shopCurrency === 'JPY') {
          return `¥${cents.toLocaleString()}`;
        }
        
        // For all other currencies, try to match the store's format
        // Detect default currency symbol based on currency code
        let currencySymbol = '$'; // Default to USD
        switch(shopCurrency) {
          case 'EUR': currencySymbol = '€'; break;
          case 'GBP': currencySymbol = '£'; break;
          case 'CAD': currencySymbol = 'CA$'; break;
          case 'AUD': currencySymbol = 'AU$'; break;
          case 'DKK': currencySymbol = 'kr.'; break;
          // Add more currencies as needed
        }
        
        // Format the price
        const amount = (cents / 100).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        
        return `${currencySymbol}${amount}`;
      } catch (error) {
        console.error('Error formatting money:', error);
        // Fallback to basic formatting
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'JPY') {
          return `¥${cents}`;
        }
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    filterByModel(btn) {
      const model = btn.dataset.model;
      const watchItems = document.querySelectorAll('#watchList .bundle-builder__product-item');

      watchItems.forEach(item => {
        const itemModel = item.dataset.model;
        const shouldShow = model === 'all' || itemModel === model;
        item.classList.toggle('hidden', !shouldShow);
      });

      // Update active button state
      const modelBtns = document.querySelectorAll('.bundle-builder__model-btn');
      modelBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      
      // Reset selected watch if it's now hidden
      if (this.selectedWatch) {
        const selectedWatchElement = document.querySelector(`#watchList .bundle-builder__product-item[data-product-id="${this.selectedWatch.id}"]`);
        if (selectedWatchElement && selectedWatchElement.classList.contains('hidden')) {
          this.selectedWatch = null;
          this.watchItems.forEach(w => w.classList.remove('selected'));
          this.updateSummary();
        }
      }
      
      // Update the debug overlay to reflect the new counts
      this.updateDebugOverlay();
    }

    updateDebugOverlay() {
      // Only update if debug mode is on
      if (!this.debugMode) return;
      
      // Check overall DOM structure
      const strapListElement = document.getElementById('strapList');
      const strapItems = strapListElement ? Array.from(strapListElement.querySelectorAll('.bundle-builder__strap-item')) : [];
      const watchItems = Array.from(document.querySelectorAll('#watchList .bundle-builder__product-item'));
      
      // Count visible items (not hidden by CSS)
      const visibleWatches = watchItems.filter(item => !item.classList.contains('hidden')).length;
      const visibleStraps = strapItems.filter(item => !item.classList.contains('hidden')).length;
      
      // Default message with DOM structure info
      if (!this.selectedWatch || !this.selectedWatch.sku) {
        this.debugOverlay.innerHTML = `
          <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px; border-bottom: 1px solid white; padding-bottom: 5px;">Bundle Builder Debug</div>
          <div>No watch selected or watch missing SKU</div>
          <div style="margin-top: 10px;">
            <div style="font-weight: bold; text-decoration: underline;">DOM Structure:</div>
            <div>Total watches: ${watchItems.length}</div>
            <div>Visible watches: ${visibleWatches}</div>
            <div>Total straps: ${strapItems.length}</div>
            <div>Visible straps: ${visibleStraps}</div>
            <div>strapList exists: ${strapListElement ? 'Yes' : 'No'}</div>
            ${strapListElement ? `<div>strapList children: ${strapListElement.children.length}</div>` : ''}
          </div>
        `;
        return;
      }

      // Get watch SKUs
      const watchSKUs = watchItems.filter(w => !w.classList.contains('hidden')).map(w => w.dataset.sku).filter(Boolean);
      const watchDetails = parseSKU(this.selectedWatch.sku);
      
      // Get all strap SKUs
      const strapSKUs = strapItems.filter(s => !s.classList.contains('hidden')).map(s => s.dataset.sku).filter(Boolean);
      
      // Get compatible strap SKUs with more details
      const compatibilityDetails = strapItems
        .filter(strap => !strap.classList.contains('hidden') && strap.dataset.sku)
        .map(strap => {
          const strapSKU = strap.dataset.sku;
          const strapDetails = parseSKU(strapSKU);
          const watch = parseSKU(this.selectedWatch.sku);
          
          // Size compatibility check
          const sizeCompatible = (watch.size === strapDetails.size * 2) || 
                                  ((watch.size === 40 || watch.size === 42) && strapDetails.size === 20);
                                  
          // Color compatibility check
          const colorCompatible = watch.color.toUpperCase() === strapDetails.color.toUpperCase();
          
          // Overall compatibility
          const isCompatibleStrap = sizeCompatible && colorCompatible;
          
          return {
            sku: strapSKU,
            title: strap.dataset.title || 'Untitled',
            size: strapDetails.size,
            color: strapDetails.color,
            sizeCompatible,
            colorCompatible,
            isCompatible: isCompatibleStrap
          };
        });
      
      // Filter for only compatible straps
      const compatibleStraps = compatibilityDetails.filter(detail => detail.isCompatible);
      
      // Create detailed HTML for the debug overlay
      this.debugOverlay.innerHTML = `
        <div style="font-weight: bold; font-size: 14px; margin-bottom: 10px; border-bottom: 1px solid white; padding-bottom: 5px;">Bundle Builder Debug</div>
        
        <div style="margin-bottom: 10px;">
          <div style="font-weight: bold; text-decoration: underline;">Watch Info:</div>
          <div>Selected SKU: ${this.selectedWatch.sku || 'N/A'}</div>
          <div>Size: ${watchDetails ? watchDetails.size : 'N/A'}, Color: ${watchDetails ? watchDetails.color : 'N/A'}</div>
          <div>Total watches: ${watchItems.length}, Visible: ${visibleWatches}</div>
        </div>
        
        <div style="margin-bottom: 10px;">
          <div style="font-weight: bold; text-decoration: underline;">Strap Info:</div>
          <div>Total straps: ${strapItems.length}, Visible: ${visibleStraps}</div>
          <div>Compatible straps: ${compatibleStraps.length}</div>
        </div>
        
        <div style="margin-bottom: 10px;">
          <div style="font-weight: bold; text-decoration: underline;">Compatible Straps (${compatibleStraps.length}):</div>
          <div style="max-height: 100px; overflow-y: auto;">
            ${compatibleStraps.length > 0 ? 
              compatibleStraps.map(strap => 
                `<div>SKU: ${strap.sku} - Size: ${strap.size}, Color: ${strap.color}</div>`
              ).join('') 
              : 'None found'
            }
          </div>
        </div>
        
        <div style="margin-bottom: 10px;">
          <div style="font-weight: bold; text-decoration: underline;">Example Compatibility Tests:</div>
          <div style="max-height: 100px; overflow-y: auto; font-size: 10px;">
            ${compatibilityDetails.slice(0, 5).map(detail => 
              `<div>
                ${detail.sku} (${detail.size}/${detail.color}) ${detail.isCompatible ? '✓' : '✗'} 
                Size: ${detail.sizeCompatible ? '✓' : '✗'}
                Color: ${detail.colorCompatible ? '✓' : '✗'}
              </div>`
            ).join('')}
          </div>
        </div>
      `;
    }

    // Deselect all watches
    deselectAllWatches() {
      this.selectedWatch = null;
      this.watchItems.forEach(w => w.classList.remove('selected'));
      this.updateSummary();
      this.updateDebugOverlay();
    }

    // Deselect all straps
    deselectAllStraps() {
      this.selectedStraps = [];
      this.strapItems.forEach(s => s.classList.remove('selected'));
      this.updateSummary();
      this.updateDebugOverlay();
    }
  }

  // Initialize the bundle builder
  const bundleBuilder = new BundleBuilder();
  window.bundleBuilder = bundleBuilder;
});